export default "__VITE_ASSET__tBKfG1vI__"